import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

/**
 * Warehouse mispick remediation APIs.
 * GET unpicked items requires a prior mispick end-of-line event on the shipment.
 */
const mispickApi = {
    /**
     * @param {number|string} shipmentId
     * @param {{ facilityId: number|string, signal?: AbortSignal } & RequestInit} [options]
     */
    getUnpickedItems: (shipmentId, options = {}) => {
        const { facilityId, ...fetchOptions } = options;
        const params = new URLSearchParams({ facilityId: String(facilityId) });
        return mmFetchWithResponse(
            `api/warehouse/v1/mispick/shipment/${shipmentId}/unpickedItems?${params}`,
            fetchOptions,
        );
    },

    /**
     * @param {{
     *   packLine: number,
     *   facilityID: number,
     *   shipmentId: number,
     *   pickerId?: number,
     *   picks: Array<{ sellableItemId: number, qtyPicked: number }>,
     *   outOfStock: number[],
     * }} payload
     * @param {RequestInit} [options]
     */
    logPicks: (payload, options = {}) =>
        mmFetchWithResponse('api/warehouse/v2/logPicks', {
            method: 'POST',
            body: JSON.stringify(payload),
            ...options,
        }),
};

export { mispickApi };
